import * as React from 'react'

import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'
import { label } from './label'

export default function NetworkRatingFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const selectedNetworkRatings = filters.selectedNetworkRatings.sort()
  const isActive = !!selectedNetworkRatings.length
  const displayLabel = label(filters.selectedNetworkRatings)

  return (
    <div data-pendo="selectedNetworkRatingsFilterButton">
      <FilterControl
        isActive={isActive}
        label={displayLabel}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
